import styled from 'styled-components'

export const Td = styled.td`
  height: inherit;
  width: 100%;
  & button {
    margin-right: 4px;
  }
`
